$(".js-img_overlay_show").on('click',function (e) {
    $currentElement = $(this);
    $(".js-img_overlay_img").attr("src", $currentElement.attr("src"));
    $(".js-img_overlay").show();

});

$(".js-img_overlay").on('click',function (e) {

});

$(".js-img_overlay_close").on('click',function (e) {
    $(".js-img_overlay").hide()
});

$(".js-img_overlay_img").on('click',function (e) {
    $(".js-img_overlay").hide()
});
